import HeaderComponent from "../../components/header/headerComponent";
import { useTranslation } from "react-i18next";
import AvantGardeCreativityPage from "./AvantGardeCreativityPage";

const AvantGardeCreativityMainPage = () => {
  const { t } = useTranslation();
  return (
    <>
    <HeaderComponent pageTitle={t(`Men's / Women's / Avant-Garde Creativity`)} >
      <AvantGardeCreativityPage  />
    </HeaderComponent>
    </>
  )
}

export default AvantGardeCreativityMainPage